import { render, staticRenderFns } from "./BackTitle.vue?vue&type=template&id=31439228&scoped=true"
import script from "./BackTitle.vue?vue&type=script&lang=js"
export * from "./BackTitle.vue?vue&type=script&lang=js"
import style0 from "./BackTitle.vue?vue&type=style&index=0&id=31439228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31439228",
  null
  
)

export default component.exports